<template>
  <section class="py-5">
    <div class="overlay-blue">
      <div class="container py-5">
        <a href="https://resmed.com/" target="_blank">
          <img
            src="@/assets/images/logo-white.png"
            alt="Resmed product support"
            class="img-fluid mb-5"
            style="height: 40px;"
          />
        </a>
        <h1 class="section-heading text-center text-white my-5">
          {{ acf.popup.heading }}
        </h1>

        <div class="row d-flex justify-content-center pb-5">
          <div class="col-lg-4 col-md-6 mb-5 m-md-0">
            <div class="card bg-white p-5 rounded">
              <img
                v-bind:src="acf.popup.product_support.image"
                class="card-img-top mx-auto img-fluid"
                alt="..."
              />
              <div class="card-body mt-5">
                <h4>{{ acf.popup.product_support.heading }}</h4>
                <p
                  class="card-text"
                  v-html="acf.popup.product_support.description"
                ></p>
                <a
                  href="#"
                  v-on:click.prevent="overlay()"
                  class="btn cta-plain text-red icon right-arrow"
                  >{{ acf.popup.product_support.cta_text }}</a
                >
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-6">
            <div class="card bg-white p-5 rounded">
              <img
                v-bind:src="acf.popup.service_technician.image"
                class="card-img-top mx-auto img-fluid"
                v-bind:alt="acf.popup.service_technician.heading"
              />
              <div class="card-body mt-5">
                <h4>{{ acf.popup.service_technician.heading }}</h4>
                <p
                  class="card-text"
                  v-html="acf.popup.service_technician.description"
                ></p>
                <a
                  target="_blank"
                  v-bind:href="acf.popup.service_technician.cta_link"
                  class="btn cta-plain text-red icon right-arrow"
                  >{{ acf.popup.service_technician.cta_text }}</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="copyright container text-center">
        <p class="text-white">
          {{ $getTranslation("Copyright", $route.params.region) }} © {{ new Date().getFullYear() }} ResMed. {{ $getTranslation("All rights reserved.", $route.params.region) }}
        </p>
      </div>
    </div>

    <div class="bg-white overlay" v-if="modal.active">
      <div class="container">
        <a href="https://resmed.com/">
          <img
            src="@/assets/images/logo-text-color.png"
            alt="Resmed product support"
            class="img-fluid mt-5"
            style="height: 40px;"
          />
        </a>
        <div class="d-flex row justify-content-center pb-5">
          <div class="text-center">
            <p class="intro mb-3">{{ acf.country_selector.introduction }}</p>
            <h1 class="mb-3">{{ acf.country_selector.heading }}</h1>
          </div>
        </div>

        <div class="row country-list pt-5">
          <div
            :class="getcolumnSize(continent.columns, 'm')"
            v-for="continent in acf.country_selector.continents"
          >
            <h4 class="pb-3 continent-name">{{ continent.name }}</h4>
            <div class="row mx-0">
              <div
                :class="getcolumnSize(continent.columns, 'd')"
                v-for="column in continent.columns"
                class="px-0"
              >
                <div v-for="country in column.countries">
                  <a v-bind:href="country.support_site_url">
                    <div class="row mx-0 pb-4">
                      <div class="col-3 px-0 pr-0 d-flex align-items-center">
                        <span
                          class="moving-left flag ff-md"
                          :class="getSlug(country.name)"
                        ></span>
                      </div>
                      <div class="col-9 px-0 name">
                        {{ country.name }}
                      </div>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "global-home",
  props: ["acf"],
  data() {
    return {
      modal: {
        active: false,
        content: {},
      },
    };
  },
  watch: {
    "modal.active"(val) {
      document.body.style["overflow"] = val ? "hidden" : "visible";
    },
  },
  methods: {
    getSlug(name) {
      return name.toLowerCase().trim().split(" ").join("-");
    },
    getcolumnSize(columns, type) {
      if (columns.length > 0) {
        if (type === "m") {
          return "col-lg-" + columns.length * 2;
        } else {
          return "col-lg-" + 12 / columns.length;
        }
      }
    },
    overlay() {
      this.modal.active = true;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";

.overlay-blue {
  // min-height: 100vh;
  background-image: url("#{$assets}/images/home-bg.svg");
  height: 100%;
  position: fixed; /* Stay in place */
  z-index: 102; /* Sit on top */
  left: 0;
  top: 0;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.9);
  width: 100%;
  transition: 0.5s;
  overflow-y: scroll;
  .container {
    position: relative;
    width: 100%; /* 100% width */
  }
}
.intro {
  font-family: "Plus Jakarta Sans", sans-serif;
  font-weight: 500;
  &::before {
    content: "";
    display: block;
    width: 1.25rem;
    border-top: 3px solid #000;
    border-radius: 5.5px;
    margin: -3px auto 16px;
  }
}
.moving-left:hover {
  transition: transform 0.3s ease;
  transform: translateX(5px);
}
.flag {
  height: 20px;
  display: block;
}
.continent-name {
  border-bottom: 1px solid #ebebeb;
  font-size: 1.375rem;
  color: #424243;
}
.name {
  color: #424243;
}
.overlay {
  height: 100%;
  position: fixed; /* Stay in place */
  z-index: 103; /* Sit on top */
  left: 0;
  top: 0;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.9);
  width: 100%;
  transition: 0.5s;

  overflow-y: scroll;
  .container {
    position: relative;
    width: 100%; /* 100% width */
  }
}
.copyright {
  padding: 5rem 0;
  border-top: 1px solid rgba(255, 255, 255, 0.5);
}
.flag {
  background-image: url("#{$assets}/images/sprite.png");
  background-repeat: no-repeat;
  background-size: 100% 49494%;
  display: inline-block;
  overflow: hidden;
  position: relative;
  vertical-align: middle;
  box-sizing: content-box;
}

.flag.ff-md {
  width: 30px;
  height: 21px;
}

.argentina {
  background-position: center 0.2287%;
}
.brazil {
  background-position: center 0.4524%;
}
.canada {
  background-position: center 0.6721%;
}
.chile {
  background-position: left 0.8958%;
}
.colombia {
  background-position: left 1.1162%;
}
.mexico {
  background-position: center 1.3379%;
}
.united-states {
  background-position: center 1.5589%;
}
.brunei {
  background-position: center 1.7836%;
}
.cambodia {
  background-position: center 2.0047%;
}
.china {
  background-position: left 2.2247%;
}
.hong-kong {
  background-position: center 2.4467%;
}
.india {
  background-position: center 2.6674%;
}
.indonasia {
  background-position: center 2.8931%;
}
.japan {
  background-position: center 3.1125%;
}
.laos {
  background-position: center 3.3325%;
}
.malaysia {
  background-position: center 3.5542%;
}
.north-korea {
  background-position: left 3.7759%;
}
.philippines {
  background-position: left 4.0015%;
}
.singapore {
  background-position: left 4.2229%;
}
.south-korea {
  background-position: center 4.441%;
}
.taiwan {
  background-position: left 4.66663%;
}
.thailand {
  background-position: center 4.8844%;
}
.vietnam {
  background-position: center 5.1061%;
}
.austria {
  background-position: center 5.3278%;
}
.belgium {
  background-position: center 5.5495%;
}
.czech-republic {
  background-position: left 5.7712%;
}
.denmark {
  background-position: center 5.994%;
}
.finland {
  background-position: center 6.2156%;
}
.france {
  background-position: center 6.4363%;
}
.germany {
  background-position: center 6.658%;
}
.ireland {
  background-position: center 6.8805%;
}
.netherlands {
  background-position: center 7.1038%;
}
.norway {
  background-position: center 7.3231%;
}
.poland {
  background-position: center 7.5448%;
}
.portugal {
  background-position: center 7.7661%;
}
.spain {
  background-position: left 7.98937%;
}
.sweden {
  background-position: center 8.2099%;
}
.switzerland,
.switzerland-de,
.switzerland-fr {
  background-position: center 8.4316%;
}
.united-kingdom {
  background-position: center 8.6533%;
}
.australia {
  background-position: center 8.875%;
}
.new-zealand {
  background-position: center 9.0967%;
}
.latin-america,
.rest-of-asia {
  background-image: url("#{$assets}/images/country-selector-flag.webp") !important;
  background-size: auto !important;
  background-position: 0 -990px;
}
.italy {
  background-image: url("#{$assets}/images/italy.webp") !important;
background-size: auto; 
  background-position: 20% !important;
}
.bolivia {
  background-image: url("#{$assets}/images/bolivia.webp") !important;
background-size: auto; 
  background-position: 20% !important;
}
.belize {
  background-image: url("#{$assets}/images/belize.png") !important;
  background-size: auto; 
  background-position: center !important;
  padding: 0px 2px;
}
.bolivia {
  background-image: url("#{$assets}/images/bolivia.png") !important;
  background-size: auto; 
  background-position: center !important;
}
.costa-rica {
  background-image: url("#{$assets}/images/costa rica.png") !important;
  background-size: auto; 
  background-position: center !important;
}
.cuba {
  background-image: url("#{$assets}/images/cuba.png") !important;
  background-size: auto; 
  background-position: center !important;
}
.ecuador {
  background-image: url("#{$assets}/images/ecuador.png") !important;
  background-size: auto; 
  background-position: center !important;
}
.el-salvador {
  background-image: url("#{$assets}/images/el salvador.png") !important;
  background-size: auto; 
  background-position: center !important;
}
.french-guiana {
  background-image: url("#{$assets}/images/french guiana.png") !important;
  background-size: auto; 
  background-position: center !important;
}
.guadeloupe {
  background-image: url("#{$assets}/images/Guadeloupe.png") !important;
  background-size: auto; 
  background-position: center !important;
  padding: 3px;
}
.guatemala {
  background-image: url("#{$assets}/images/guatemala.png") !important;
  background-size: auto; 
  background-position: center !important;
}
.guyana {
  background-image: url("#{$assets}/images/guyana.png") !important;
  background-size: auto; 
  background-position: center !important;
}
.haiti {
  background-image: url("#{$assets}/images/haiti.png") !important;
  background-size: auto; 
  background-position: center !important;
}
.honduras {
  background-image: url("#{$assets}/images/Honduras.png") !important;
  background-size: auto; 
  background-position: center !important;
}
.martinique {
  background-image: url("#{$assets}/images/Martinique.png") !important;
  background-size: auto; 
  background-position: center !important;
}
.nicaragua {
  background-image: url("#{$assets}/images/Nicaragua.png") !important;
  background-size: auto; 
  background-position: center !important;
}
.panama {
  background-image: url("#{$assets}/images/panama.png") !important;
  background-size: auto; 
  background-position: center !important;
}
.paraguay {
  background-image: url("#{$assets}/images/Paraguay.png") !important;
  background-size: auto; 
  background-position: center !important;
}
.peru {
  background-image: url("#{$assets}/images/peru.png") !important;
  background-size: auto; 
  background-position: center !important;
}
.puerto-rico {
  background-image: url("#{$assets}/images/Puerto Rico.png") !important;
  background-size: auto; 
  background-position: center !important;
}
.paraguay {
  background-image: url("#{$assets}/images/Paraguay.png") !important;
  background-size: auto; 
  background-position: center !important;
}
.dominican-republic {
  background-image: url("#{$assets}/images/republician.png") !important;
  background-size: auto; 
  background-position: center !important;
}
.saint-barthelemy {
  background-image: url("#{$assets}/images/Saint Barthelemy.png") !important;
  background-size: auto; 
  background-position: center !important;
}
.saint-martin{
  background-image: url("#{$assets}/images/Saint Martin.png") !important;
  background-size: auto; 
  background-position: center !important;
}
.uruguay {
  background-image: url("#{$assets}/images/Uruguay.png") !important;
  background-size: auto; 
  background-position: center !important;
}
.venezuela{
  background-image: url("#{$assets}/images/Venezuela.png") !important;
  background-size: auto; 
  background-position: center !important;
}
.suriname{
  background-image: url("#{$assets}/images/Suriname.png") !important;
  background-size: auto; 
  background-position: center !important;
}

</style>
